import React from 'react';

import { constants, useBetHistoryItemState } from '@atlas/core';
import { BetHistoryItemMoreInfo, BetHistoryItemPayout, BetOutcomeCard, Button } from '@atlas/ui';

import BetOutcomeLink from 'common/BetOutcomeLink';

import Cashout from '../Cashout/Cashout';

const { CASH_OUT } = constants.BET_STATUS;

const defaultAmountOfOutcomesToHide = 3;

const BetHistoryItemCompact = props => {
  const {
    amountOfOutcomesToHide = defaultAmountOfOutcomesToHide,
    cashoutDisabled,
    eventsData = {},
    handleToggleEditMode,
    isMobile = false,
    isShortViewType,
    orderCashoutDisabled,
    partialCashoutDisabled,
    setIsOpenPopup,
    showEditButton,
  } = props;
  const [isShowMore, setShowMore] = React.useState(!!isShortViewType);
  const handleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

  const { betStatus, betType, estimatedCashOut, estimatedPartialCashOut, loading, outcomes } =
    useBetHistoryItemState();

  const displayedOutcomes = React.useMemo(
    () => (isShowMore ? outcomes : outcomes.slice(0, amountOfOutcomesToHide)),
    [isShowMore, outcomes, amountOfOutcomesToHide],
  );

  const shouldOrderCashout = !orderCashoutDisabled;
  const shouldPartialCashout = !partialCashoutDisabled && !!estimatedPartialCashOut;
  const shouldRenderCashout = betStatus !== CASH_OUT && !!estimatedCashOut && !cashoutDisabled;

  return (
    <div className="bet-order-default compact">
      <div className="bet-order-report">
        <BetHistoryItemPayout />
      </div>

      <div className="bet-order-outcomes">
        {displayedOutcomes.map(outcome => (
          <BetOutcomeCard
            BetOutcomeLink={BetOutcomeLink}
            betStatus={betStatus}
            betType={betType}
            eventData={eventsData[outcome.outcomeInfo.eventId]}
            hasDetachedEventTracking
            isMobile={isMobile}
            isShowMore={isShowMore}
            key={outcome.outcomeId}
            outcome={outcome}
            setIsOpenPopup={setIsOpenPopup}
          />
        ))}
      </div>

      {isShowMore && <BetHistoryItemMoreInfo BetOutcomeLink={BetOutcomeLink} />}

      <div className="bet-order-report">
        <div className="bet-order-report__buttons">
          {isShortViewType && showEditButton && (
            <Button
              className="bet-order-report__more"
              disabled={loading}
              label="edit_bet"
              onClick={handleToggleEditMode}
              size="medium"
              type="secondary"
            />
          )}

          {!isShortViewType && (
            <Button
              className="bet-order-report__more"
              label={isShowMore ? 'Less' : 'More'}
              onClick={handleShowMore}
              size="medium"
              type="secondary"
            />
          )}

          {shouldRenderCashout && (
            <Cashout
              orderCashoutDisabled={!shouldOrderCashout}
              partialCashoutDisabled={!shouldPartialCashout}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BetHistoryItemCompact;
